import { IRequestEventHandler } from "../common";
import { BaseDocRequestV2 } from "../documents/baseDocRequestV2";
import { IInvoiceCashOrderCreateDTO, IInvoiceCashOrderEditDTO, IInvoiceCashOrderGetDTO, IInvoiceCashOrderViewDTO } from "../../coreapi-dto/documents/invoiceCashOrder";
import { IBaseDocumentItemDTO, IBaseDocumentItemViewDTO } from "../../coreapi-dto/documents/base";

export class InvoiceCashOrderRequest extends BaseDocRequestV2<IInvoiceCashOrderViewDTO, IInvoiceCashOrderGetDTO, IInvoiceCashOrderCreateDTO, IInvoiceCashOrderEditDTO, IBaseDocumentItemViewDTO, IBaseDocumentItemDTO> {
    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler, routePrefix: string) {
        super(baseUrl, routePrefix, token, eventHandler);
    }
}
export default InvoiceCashOrderRequest;